/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './LayersView.scss';
import BasePanel from '../../Panels';

import PublishLayer from '../../Panels/PublishLayer';
import ImportEksport from '../../Panels/ImportEksport';
import LayerDetails from '../../Panels/LayerDetails';
import Dictionaries from '../../Panels/Dictionaries';
import AddWms from '../../Panels/AddWms';


class LayersView extends React.Component {
  render() {
    return (
      <div>
        <div className="col-sm-6">
          <BasePanel fullWidth user={this.props.user}  style={{textAlign: "center"}} userHasFeatureCode="0009" panelType="info" panelTitle="Import/eksport"><ImportEksport /></BasePanel>
          <BasePanel fullWidth user={this.props.user} userHasFeatureCode="0003" panelType="warning" panelTitle="Szczegóły warstwy"><LayerDetails /></BasePanel>
          <BasePanel fullWidth user={this.props.user} userHasFeatureCode="0017" panelType="warning" panelTitle="Dodawanie i usuwanie słowników"><Dictionaries /></BasePanel>
        </div>
        <div className="col-sm-6">
          <BasePanel fullWidth user={this.props.user} userHasFeatureCode="0002" panelType="success" panelTitle="Tworzenie heatmap">Panelek</BasePanel>
          <BasePanel fullWidth user={this.props.user} userHasFeatureCode="0004" panelType="danger" panelTitle="Dodawanie zewnętrznych warstw WMS/WMTS"><AddWms /></BasePanel>
          <BasePanel fullWidth user={this.props.user} userHasFeatureCode="0004" panelType="danger" panelTitle="Publikacja warstwy"><PublishLayer district={this.props.district} /></BasePanel>
        </div>
      </div>
    );
  }
}

LayersView.PropTypes = {
  viewName: PropTypes.string.isRequired,
  viewDesc: PropTypes.string.isRequired,
};

export default withStyles(s)(LayersView);



// WEBPACK FOOTER //
// src/components/Modals/Settings/SettingsViews/LayersView/LayersView.js